import HttpService from './HttpService'

const _http = new HttpService()
export default {
  transfer: (payload) => {
    return _http.post('/api/operators-appointment-history/transfer', payload)
  }
}